import { render, staticRenderFns } from "./humannav.vue?vue&type=template&id=fca11a1e"
import script from "./humannav.vue?vue&type=script&lang=js"
export * from "./humannav.vue?vue&type=script&lang=js"
import style0 from "./humannav.vue?vue&type=style&index=0&id=fca11a1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports